import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67f27160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_2 = { class: "button-group mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Data Stream Table Name", -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Column Order", -1))
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "CSV URI", -1))
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Upload CSV", -1))
const _hoisted_16 = { class: "d-flex align-items-center gap-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_19 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_20 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_21 = { class: "mb-2 small text-muted" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = {
  class: "progress mb-3",
  style: {"height":"8px"}
}
const _hoisted_27 = ["aria-valuenow"]
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "col-12 mt-3" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldMapper = _resolveComponent("FieldMapper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card mb-25 border-0 rounded-0 bg-white add-product-box", { loading: _ctx.isLoading }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn", _ctx.importType === 'sku' ? 'btn-primary' : 'btn-outline-primary']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectImportType('sku')))
        }, " SKU Data ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn", _ctx.importType === 'order' ? 'btn-primary' : 'btn-outline-primary']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectImportType('order')))
        }, " Order Data ", 2)
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.dataStreamTableName) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.form.dataStreamTableName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.columnOrder) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.form.columnOrder]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.csvUri) = $event)),
                placeholder: "Will be set automatically after upload",
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.form.csvUri]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCsvDialog && _ctx.openCsvDialog(...args))),
                  disabled: _ctx.upload.inProgress || _ctx.isUploading
                }, " Choose CSV ", 8, _hoisted_17),
                (_ctx.selectedFileName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.selectedFileName), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "No file selected"))
              ]),
              _createElementVNode("div", {
                class: "csv-dropzone mt-2",
                onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCsvDrop && _ctx.onCsvDrop(...args)), ["prevent"]))
              }, " Drag & drop CSV here ", 32),
              _createElementVNode("input", {
                ref: "csvInput",
                type: "file",
                accept: ".csv,text/csv",
                class: "d-none",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCsvChange && _ctx.onCsvChange(...args)))
              }, null, 544)
            ])
          ]),
          (_ctx.upload.inProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.upload.phase === 'uploading')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Uploading…"))
                    : (_ctx.upload.phase === 'committing')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Finalising…"))
                      : (_ctx.upload.phase === 'done')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Completed"))
                        : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.humanBytes(_ctx.upload.loaded)) + " / " + _toDisplayString(_ctx.humanBytes(_ctx.upload.total)) + " ", 1),
                  (_ctx.upload.percent >= 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, " (" + _toDisplayString(_ctx.upload.percent) + "%)", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({ width: _ctx.upload.percent + '%'}),
                    "aria-valuenow": _ctx.upload.percent,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 12, _hoisted_27)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.mapperReady && !_ctx.mapperCrashed && Array.isArray(_ctx.sourceFields) && Array.isArray(_ctx.targetFields))
              ? (_openBlock(), _createBlock(_component_FieldMapper, {
                  key: 0,
                  sourceFields: _ctx.sourceFields,
                  targetFields: _ctx.targetFields,
                  onColumnOrderGenerated: _ctx.setColumnOrder
                }, null, 8, ["sourceFields", "targetFields", "onColumnOrderGenerated"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "submit",
              disabled: _ctx.isLoading || _ctx.upload.inProgress || !_ctx.form.csvUri
            }, " Submit Import ", 8, _hoisted_30)
          ])
        ])
      ], 32)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      : _createCommentVNode("", true)
  ], 2))
}